import React from "react";
import Banner from "../../assets/Sap_to_sleep_banner.png";
import MBanner from "../../assets/saptosleepBanner-mobile.png";
import Saptosleep2 from "../../assets/saptosleep-2.jpg";
import saptosleep3 from "../../assets/saptosleep-3.jpg";
import saptosleep4 from "../../assets/Saptosleep-4.jpg";
import Icon1 from '../../assets/icons/Saptosleep/icon-1.png'
import Icon2 from '../../assets/icons/Saptosleep/icon-2 copy.png'
import Icon3 from '../../assets/icons/Saptosleep/icon-3 copy.png'
import Icon4 from '../../assets/icons/Saptosleep/icon-4 copy.png'
export default function SapToSleep() {
  return (
    <div>
      <div className="relative w-full  md:pt-16 lg:pt-20 3xl:pt-0">
        {/* Image */}
        <img
          src={Banner}
          alt="Latex Journey"
          className="w-full h-auto object-cover hidden md:flex"
        />
        <img
          src={MBanner}
          alt="Latex Journey"
          className="w-full h-auto object-cover flex md:hidden"
        />

        {/* Overlay Content */}
        <div className="absolute top-[30%] xl:top-[25%] 3xl:top-[20%] left-1/2 -translate-x-1/2 -translate-y-1/2 text-center w-[90%] px-4">
          <h1 className="text-[#3a683f] text-[24px] md:text-[32px] lg:text-[40px] xl:text-[52px] 3xl:text-[60px] font-extralight font-lexend tracking-wide">
            THE JOURNEY OF LATEX
          </h1>

          <p className="mt-2 font-lexend font-light text-[#3a683f] text-[14px] md:text-[16px] xl:text-[18px] 3xl:text-[20px]">
            How latex mattresses are manufactured at Moondew
          </p>
        </div>
      </div>
      <div className="bg-[#fdf9ed] ">
        <div className="sm:max-w-full md:max-w-[80%] xl:max-w-[80rem] 3xl:max-w-[90rem] mx-auto">
          <div className="flex flex-col justify-center items-center text-center py-14">
            <h2 className="text-[#3a683f] text-[24px] md:text-[32px] xl:text-[42px] 3xl:text-[60px] font-extralight font-lexend  xl:leading-[48px] 3xl:leading-[70px] tracking-wide">
              Before it becomes your mattress, <br /> latex begins its journey
              in the lap of nature
            </h2>
            <p className="font-lexend font-light text-[#6d6d6d] text-[14px] md:text-[16px] xl:text-[18px] 3xl:text-[20px] pt-5 xl:pt-8">
              Latex is a natural substance derived from the sap of rubber trees,
              scientifically known as Hevea brasiliensis. <br /> This milky
              fluid is carefully tapped from the tree and processed into a
              versatile material used in mattresses, pillows, and more.
            </p>
          </div>
          <div className="">
            <div className="flex flex-col xl:flex-row justify-between bg-[#3a683f]  items-center ">
              <div className="w-[90%] xl:w-[40%] 3xl:w-[60%] mx-auto">
                <h3 className="font-lexend font-light text-[#fff] text-[20px] xl:text-[28px] 3xl:text-[36px] leading-normal 3xl:leading-[46px] w-full 3xl:w-[82.34%] mx-auto py-10 xl:py-0 ">
                  At Moondew, we partner with manufacturers in Sri Lanka who
                  follow the traditional Dunlop process to create high-quality
                  latex foam used across our products.
                </h3>
              </div>
              <div className="">
                <img src={Saptosleep2} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="sm:max-w-full md:max-w-[80%] xl:max-w-[80rem] 3xl:max-w-[90rem] mx-auto px-5 xl:px-0">
        <div className="grid grid-cols-1 xl:grid-cols-[60%_40%] pt-14">
          <div>
            <div>
              <h2 className="text-[24px] md:text-[38px] xl:text-[42px] 3xl:text-[52px] font-light font-lexend leading-normal xl:leading-[48px] 3xl:leading-[64px] text-[#3a683f]">
                Understanding <br />
                the Dunlop process
              </h2>
              <p className="text-[14px] md:text-[16px] xl:text-[18px] 3xl:text-[20px] text-[#6d6d6d] font-lexend font-light w-full xl:w-[70%] py-3">
                The Dunlop process is one of the oldest and most trusted metn of
                making latex foam. It is valued for its simplicity, consistency,
                and ability to retain the natural qualities of latex.
              </p>
              <p className="text-[14px] md:text-[16px] xl:text-[18px] 3xl:text-[20px] text-[#6d6d6d] font-lexend font-light w-[70%] ">
                Here's how the process comes together.
              </p>
              <div className="mt-5">
                <div className="flex xl:gap-10 gap-5 ">
                  <div className="flex justify-center items-center bg-[#fdf9ed] w-10 h-10  xl:w-16 xl:h-16 border border-[#3a683f] rounded-full">
                    <span className="font-lexend font-medium text-24px xl:text-[36px] text-[#3a683f]">
                      1
                    </span>
                  </div>
                  <div className="w-[80%]">
                    <h4 className="font-lexend font-semibold text-[14px] md:text-[16px] xl:text-[18px] 3xl:text-[20px] text-[#333333] ">
                      Latex extraction
                    </h4>
                    <p className="text-[14px] md:text-[16px] xl:text-[18px] 3xl:text-[20px] font-light font-lexend text-[#6d6d6d]">
                      The journey begins with extracting natural latex sap from
                      rubber trees. tapping process that allows the tree This is
                      done through a careful tapping process sustainable an to
                      continue growing, making it a sustainable and renewable
                      source.
                    </p>
                  </div>
                </div>
                <div className="flex xl:gap-10 gap-5 py-8">
                  <div className="flex justify-center items-center bg-[#fdf9ed]  w-10 h-10  xl:w-16 xl:h-16 border border-[#3a683f] rounded-full">
                    <span className="font-lexend font-medium text-24px xl:text-[36px] text-[#3a683f]">
                      2
                    </span>
                  </div>
                  <div className="w-[80%] xl:w-[72%]">
                    <h4 className="font-lexend font-semibold text-[14px] md:text-[16px] xl:text-[18px] 3xl:text-[20px] text-[#333333] ">
                      Mixing and formulation
                    </h4>
                    <p className="text-[14px] md:text-[16px] xl:text-[18px] 3xl:text-[20px] font-light font-lexend text-[#6d6d6d]">
                      The collected latex is then mixed and processed to achieve
                      the right consistency and performance. This step plays an
                      important role in defining how the final foam will feel in
                      terms of support, co and durability.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <img src={saptosleep3} alt="" />
          </div>
        </div>
        <div className="grid grid-cols-1 xl:grid-cols-[40%_60%] gap-8 mt-5">
          <div className="order-2 xl:order-1">
            <img src={saptosleep4} alt="" />
          </div>
          <div className="order-1 xl:order-2">
            <div className="flex xl:gap-10 gap-5 ">
              <div className="flex justify-center items-center bg-[#fdf9ed]  w-10 h-10  xl:w-16 xl:h-16 border border-[#3a683f] rounded-full">
                <span className="font-lexend font-medium text-24px xl:text-[36px] text-[#3a683f]">
                  3
                </span>
              </div>
              <div className="w-[80%]">
                <h4 className="font-lexend font-semibold text-[14px] md:text-[16px] xl:text-[18px] 3xl:text-[20px] text-[#333333] ">
                  Mold pouring
                </h4>
                <p className="text-[14px] md:text-[16px] xl:text-[18px] 3xl:text-[20px] font-light font-lexend text-[#6d6d6d]">
                  Once ready, the latex mixture is poured into molds in specific
                  quantities. These molds help create different sizes,
                  densities, and firmness levels, allowing the mattress to suit
                  different comfort needs.
                </p>
              </div>
            </div>
            <div className="flex xl:gap-10 gap-5 py-8">
              <div className="flex justify-center items-center bg-[#fdf9ed] w-10 h-10  xl:w-16 xl:h-16 border border-[#3a683f] rounded-full">
                <span className="font-lexend font-medium text-24px xl:text-[36px] text-[#3a683f]">
                  4
                </span>
              </div>
              <div className="w-[80%]">
                <h4 className="font-lexend font-semibold text-[14px] md:text-[16px] xl:text-[18px] 3xl:text-[20px] text-[#333333] ">
                  Heat curing
                </h4>
                <p className="text-[14px] md:text-[16px] xl:text-[18px] 3xl:text-[20px] font-light font-lexend text-[#6d6d6d]">
                  The filled molds are heated in a controlled environment. This
                  process, known as vulcanization, helps the latex solidify and
                  form its unique strcture enath, elasticity and its unique
                  structure, giving it strength, elasticity, and resilience.
                </p>
              </div>
            </div>
            <div className="flex xl:gap-10 gap-5">
              <div className="flex justify-center items-center bg-[#fdf9ed] w-10 h-10  xl:w-16 xl:h-16 border border-[#3a683f] rounded-full">
                <span className="font-lexend font-medium text-24px xl:text-[36px] text-[#3a683f]">
                  5
                </span>
              </div>
              <div className="w-[80%]">
                <h4 className="font-lexend font-semibold text-[14px] md:text-[16px] xl:text-[18px] 3xl:text-[20px] text-[#333333] ">
                  Washing and drying
                </h4>
                <p className="text-[14px] md:text-[16px] xl:text-[18px] 3xl:text-[20px] font-light font-lexend text-[#6d6d6d]">
                  After curing, the latex foam is thoroughly washed to remove
                  any residual impurities. It is then dried carefully to ensure
                  it remains clean, hygienic, and long-lasting.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-[#fdf9ed] py-10 3xl:py-20">
        <div className="sm:max-w-full md:max-w-[80%] xl:max-w-[80rem] 3xl:max-w-[90rem] mx-auto px-5 xl:px-0">
          <div>
            <h2 className="text-[24px] md:text-[38px] xl:text-[42px] 3xl:text-[52px] font-lexend font-light text-[#3a683f]">
              Advantages of the Dunlop process
            </h2>
            <p className=" text-[14px] md:text-[16px] xl:text-[18px] 3xl:text-[20px] font-lexend font-light text-[#6d6d6d]">
              The Dunlop process offers several advantages that contribute to
              the exceptional quality of latex foam.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 mt-5 xl:mt-14">
            {/* CARD 1 */}
            <div className="bg-white p-8 text-center h-full">
              <img
                src={Icon1}
                alt=""
                className="w-[60px] h-[60px] md:w-[80px] md:h-[80px] 3xl:w-auto 3xl:h-auto mx-auto mb-6"
              />

              <h3 className="font-lexend text-[#3a683f] text-[14px] md;text-[16px] 3xl:text-[18px] font-bold">
                Consistent performance
              </h3>

              <p className="text-[#6d6d6d] font-lexend text-[14px] md;text-[16px] 3xl:text-[18px] font-light mt-3">
                The process ensures uniform density and firmness across the
                mattress, giving you a reliable and balanced sleep experience.
              </p>
            </div>

            {/* CARD 2 */}
            <div className="bg-white p-8 text-center h-full">
              <img
                src={Icon2}
                alt=""
                className="w-[60px] h-[60px] md:w-[80px] md:h-[80px] 3xl:w-auto 3xl:h-auto mx-auto mb-6"
              />

              <h3 className="font-lexend text-[#3a683f] text-[14px] md;text-[16px] 3xl:text-[18px] font-bold">
                Long-lasting support
              </h3>

              <p className="text-[#6d6d6d] font-lexend text-[14px] md;text-[16px] 3xl:text-[18px] font-light mt-3">
                Dunlop latex is naturally durable. It retains its shape and
                support over time without sagging.
              </p>
            </div>

            {/* CARD 3 */}
            <div className="bg-white p-8 text-center h-full">
              <img
                src={Icon3}
                alt=""
                className="w-[60px] h-[60px] md:w-[80px] md:h-[80px] 3xl:w-auto 3xl:h-auto mx-auto mb-6"
              />

              <h3 className="font-lexend text-[#3a683f] text-[14px] md;text-[16px] 3xl:text-[18px] font-bold">
                Naturally breathable and hypoallergenic
              </h3>

              <p className="text-[#6d6d6d] font-lexend text-[14px] md;text-[16px] 3xl:text-[18px] font-light mt-3">
                Because it is made from natural latex, it allows airflow and
                resists dust mites, mold, and microbes.
              </p>
            </div>

            {/* CARD 4 */}
            <div className="bg-white p-8 text-center h-full">
              <img
                src={Icon4}
                alt=""
                className="w-[60px] h-[60px] md:w-[80px] md:h-[80px] 3xl:w-auto 3xl:h-auto mx-auto mb-6"
              />

              <h3 className="font-lexend text-[#3a683f] text-[14px] md;text-[16px] 3xl:text-[18px] font-bold">
                Environmentally friendly
              </h3>

              <p className="text-[#6d6d6d] font-lexend text-[14px] md;text-[16px] 3xl:text-[18px] font-light mt-3">
                With sustainably sourced latex and a straightforward production
                method, the Dunlop process supports eco-conscious manufacturing.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
